import {Seat, Point} from '../../../schemas';
const RAD = (180 / Math.PI);
const LARGE_RADIUS = 1000000;
const LARGE_RADIUS_INVERSE = -1 * LARGE_RADIUS;

export default function decodeSeatGeometry (seatInfo, sectionInfo) {
  const rowNum = seatInfo.rowNum;
  const seatNum = seatInfo.seatNum;

  // This is the final value of the seat location
  const seat = new Seat({
    id:           seatInfo.id,
    available:    seatInfo.available,
    blockingCode: seatInfo.blockingCode,
    section:      seatInfo.section,
    row:          seatInfo.row,
    seat:         seatInfo.seat,
    priceLevel:   seatInfo.priceLevel,
    attributes:   seatInfo.attributes,
    // size:         seatSize,              // due to a Chrome patch
    // position will be updated later
    position:     new Point({x: 0, y: 0})
  });

  // initial data
  let theta = Math.PI / 2;
  let DCIndexStart = 0;
  let centerSpot = {x: 0, y: 0 };
  let centerRadius = 0;
  const center = sectionInfo.center;
  const startingSeatSpot = {
    x: rowNum * sectionInfo.skew,
    y: rowNum * sectionInfo.spacing.row
  };

  const deltas = {
    x:      seatNum * sectionInfo.spacing.seat,
    y:      seatNum * sectionInfo.dTangentialY,
    a:      0,
    t:      0,
    c:      0,
    pna:    sectionInfo.pna,
    pnp:    sectionInfo.pnp,
    center: sectionInfo.deltaCenter
  };

  // ADJUSTMENTS
  let dcStartIndexDefined = false;
  sectionInfo.adjustments.forEach(adj => {
    if (adj.row === rowNum && adj.seat <= seatNum) {
      deltas.a += adj.da / RAD;
      deltas.t += adj.dt / RAD;
      deltas.c += adj.dc;

      if (deltas.c !== 0 && !dcStartIndexDefined) {
        dcStartIndexDefined = true;
        DCIndexStart = adj.seat;

        deltas.x = adj.dx;
        deltas.y = adj.dy;
      }
      else {
        deltas.x += adj.dx;
        deltas.y += adj.dy;
      }
    }
  });

  if (center.y < LARGE_RADIUS_INVERSE && deltas.t === 0 && deltas.c === 0) {
    // ultra simple rectangle shape??
    seat.position.x = startingSeatSpot.x + deltas.x;
    seat.position.y = -1 * (startingSeatSpot.y + deltas.y); // WHY IS THIS INVERTED???
  }
  else {
    // OK, we are in a curvature situation here
    if (deltas.c === 0) {

      centerSpot = {
        x: rowNum * deltas.center.x + center.x,
        y: rowNum * deltas.center.y + center.y
      };

      const deltaMove = {
        x: startingSeatSpot.x - centerSpot.x,
        y: startingSeatSpot.y - centerSpot.y
      };

      centerRadius = Math.sqrt(deltaMove.x * deltaMove.x + deltaMove.y * deltaMove.y);
      theta = Math.atan2(deltaMove.y, deltaMove.x) + deltas.t;

      if (centerRadius >= LARGE_RADIUS) {
        // is this a rectangular shape?
        seat.position.x = startingSeatSpot.x + deltas.x * Math.sin(theta) + deltas.y * Math.cos(theta);
        seat.position.y = -1 * (startingSeatSpot.y - deltas.x * Math.cos(theta) + deltas.y * Math.sin(theta));
      }
      else {
        // this is a wedge shape
        theta = theta - (deltas.x / centerRadius);
        centerRadius += deltas.y;

        seat.position.x = centerSpot.x + centerRadius * Math.cos(theta);
        seat.position.y = centerSpot.y + centerRadius * Math.sin(theta);

        seat.position.y = -1 * seat.position.y;
      }

    }
    else {
      // TEST THIS
      theta = (Math.PI / 2) + deltas.t;
      const alpha = Math.PI - 2 * Math.acos(Math.abs(deltas.c) / Math.abs(sectionInfo.spacing.seat));

      if (sectionInfo.spacing.seat >= 0) {
        theta -= alpha * (seatNum - DCIndexStart);
      }
      else {
        theta += alpha * (seatNum - DCIndexStart);
      }

      centerRadius = Math.abs(deltas.c) / (1 - Math.cos(alpha));
      centerSpot.x = startingSeatSpot.x + deltas.x;
      centerSpot.y = startingSeatSpot.y + deltas.y;

      if (deltas.c > 0) {
        centerSpot.y += centerRadius;
        theta = -1 * theta;
      }
      else {
        centerSpot.y -= centerRadius;
      }

      seat.position.x = centerSpot.x + centerRadius * Math.cos(theta);
      seat.position.y = -1 * (centerSpot.y + centerRadius * Math.sin(theta));
    }
  }

  // Chrome patch - begin
  const relativeScale = sectionInfo.scale / 100;
  const seatSize = (sectionInfo.scale / 2).toFixed(2);
  seat.size = seatSize;
  // Chrome patch - end

  seat.position.x = ((seat.position.x * relativeScale) + +seatSize).toFixed(2);
  seat.position.y = ((seat.position.y * relativeScale) + +seatSize).toFixed(2);

  return seat;
}



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/decoders/seat_decoder.js